<app-navbar></app-navbar>

<div class="container">
    <h1>Terms and Conditions</h1>
    <p>Welcome to <b>BrandQrCodes</b>!</p>
    <p>
        These terms and conditions outline the rules and regulations for the use of
        <b>BrandQrCodes</b>'s Website, located
        <a routerLink="/">https://brandqrcodes.com</a>.
    </p>

    <p>
        By accessing this website we assume you accept these terms and conditions.
        Do not continue to use <b>BrandQrCodes</b> if you do not agree to take all of
        the terms and conditions stated on this page.
    </p>

    <p>
        The following terminology applies to these Terms and Conditions, Privacy
        Statement and Disclaimer Notice and all Agreements: "Client", "You" and
        "Your" refers to you, the person log on this website and compliant to the
        Company’s terms and conditions. "The Company", "Ourselves", "We", "Our" and
        "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the
        Client and ourselves. All terms refer to the offer, acceptance and
        consideration of payment necessary to undertake the process of our
        assistance to the Client in the most appropriate manner for the express
        purpose of meeting the Client’s needs in respect of provision of the
        Company’s stated services, in accordance with and subject to, prevailing law
        of Netherlands. Any use of the above terminology or other words in the
        singular, plural, capitalization and/or he/she or they, are taken as
        interchangeable and therefore as referring to same.
    </p><br>

    <h2>1. Cookies</h2>

    <p>
        We employ the use of cookies. By accessing <b>BrandQrCodes</b>, you agreed to
        use cookies in agreement with the <b>BrandQrCodes</b>'s
        <a routerLink="/privacy-policy">Privacy Policy</a>.
    </p>

    <p>
        Most interactive websites use cookies to let us retrieve the user’s details
        for each visit. Cookies are used by our website to enable the functionality
        of certain areas to make it easier for people visiting our website. Some of
        our affiliate/advertising partners may also use cookies.
    </p><br>

    <h2>2. License</h2>

    <p>
        Unless otherwise stated, <b>BrandQrCodes</b> and/or its licensors own the
        intellectual property rights for all material on <b>BrandQrCodes</b>. All
        intellectual property rights are reserved. You may access this from
        <b>BrandQrCodes</b> for your own personal use subjected to restrictions set in
        these terms and conditions.
    </p>

    <p>You must not:</p>
    <ul>
        <li>Republish material from <b>BrandQrCodes</b></li>
        <li>Sell, rent or sub-license material from <b>BrandQrCodes</b></li>
        <li>Reproduce, duplicate or copy material from <b>BrandQrCodes</b></li>
        <li>Redistribute content from <b>BrandQrCodes</b></li>
    </ul>

    <p>This Agreement shall begin on the date hereof.</p>

    <p>
        You hereby grant <b>BrandQrCodes</b> a non-exclusive license to use, reproduce,
        edit and authorize others to use, reproduce and edit any of your Comments in
        any and all forms, formats or media.
    </p><br>

    <h2>3. Hyperlinking to our Content</h2>

    <p>
        Any organization may link to our home page, to publications or to other Website information so long as the link:
    </p>

    <ul class="no-dots">
        <li>(a) is not in any way deceptive;</li>
        <li>(b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or
            services; and</li>
        <li>(c) fits within the context of the linking party’s site.</li>
    </ul>

    <p>
        These organizations may link to our home page so long as the link:
    </p>
    <ul class="no-dots">
        <li>(a) is not in any way deceptive; </li>
        <li>(b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or
            services; and </li>
        <li>(c) fits within the context of the linking party’s site.</li>
    </ul>

    <p>
        No use of <b>BrandQrCodes</b>'s logo or other artwork will be allowed for
        linking absent a trademark license agreement.
    </p><br>

    <h2>4. Content Liability</h2>

    <p>
        We shall not be hold responsible for any content that appears on your
        Website. You agree to protect and defend us against all claims that is
        rising on your Website. No link(s) should appear on any Website that may be
        interpreted as libelous, obscene or criminal, or which infringes, otherwise
        violates, or advocates the infringement or other violation of, any third
        party rights.
    </p><br>

    <h2>5. API Usage</h2>

    <p>
        There is a request limit depending on your subscription plan plus we reserve the right to reject API requests,
        block API Keys and/or request IP addresses. This especially applies to requests that we deem offensive or
        improper
        (i.e. if it seems to
        be a DoS attack). Because of this, we only keep track of request’s origin IP address, <b>not the information
            included in the QR codes</b>.
        <br> Please <a routerLink="/contact-us" target="_blank">let us know</a> if your service consistently requires
        <b>more than a
            million requests
            per month</b> or if it is being incorrectly blocked.
    </p><br>

    <h2>6. BrandQRcodes Referral Program</h2>

    <h4 class="ps-2">6.1. Eligibility</h4>
    <ul class="no-dots">
        <li>6.1.1 The BrandQRcodes Referral Program is open to individuals and businesses worldwide.</li>
        <li>6.1.2 Participants must meet the age requirements stipulated by their jurisdiction, which may vary.
            In most
            cases,
            participants must be at least 18 years old.</li>
    </ul>

    <h4 class="ps-2">6.2. Enrollment</h4>
    <ul class="no-dots">
        <li>
            6.2.1 To enroll in the Program, participants must complete the registration process by creating an account
            through
            our sign up page on BrandQRcodes.
        </li>
        <li>
            6.2.2 Each individual or business entity is allowed only one account.
        </li>
    </ul>

    <h4 class="ps-2">6.3. Commissions</h4>
    <ul class="no-dots">
        <li>
            6.3.1 Participants will earn an enticing 20% commission on the total sale amount for every user that signed
            up
            through their unique referral link.
        </li>
        <li>
            6.3.2 Commissions are calculated based on the actual sale amount before taxes, or any additional charges.
        </li>
        <li>
            6.3.3 Commissions will be disbursed when upon user’s requests and payment will be made through PayPal,
            provided that
            the participant's commission balance exceeds the minimum payout threshold determined by BrandQRcodes
            ($50 USD).
        </li>
        <li>
            6.3.4 Commission payments may be subject to verification and may experience delays due to any suspicion of
            fraudulent activity or abuse.
        </li>
    </ul>
    <h4 class="ps-2">6.4. Referral Period</h4>
    <ul class="no-dots">
        <li>
            6.4.1 Participants are entitled to commissions on all eligible purchases made by any user that signed up
            through
            their referral link for a duration of one year from the sign-up date of the referred user.
        </li>
    </ul>

    <h4 class="ps-2">6.5. Promotional Guidelines</h4>
    <ul class="no-dots">
        <li>
            6.5.1 Participants are encouraged to promote BrandQRcodes's products and services in a responsible and
            ethical
            manner.
        </li>
        <li>
            6.5.2 Participants must refrain from any form of spamming, false advertising, or any other unethical
            practices when
            promoting their referral links.
        </li>
        <li>
            6.5.3 Our products and services should NOT be promoted on any pornographic website or in any context that
            violates
            decency and common standards of appropriateness.
        </li>
        <li>
            6.5.4 Participants must NOT pretend to be acting on behalf of BrandQRcodes, such as impersonating an
            employee or
            representative of the company.
        </li>
    </ul>

    <h4 class="ps-2">6.6. Payment Method</h4>
    <ul class="no-dots">
        <li>
            6.6.1 Currently, BrandQRcodes exclusively accepts PayPal as the designated payment method for commission
            payouts.
        </li>
    </ul>

    <h4 class="ps-2">6.7. Termination</h4>
    <ul class="no-dots">
        <li>
            6.7.1 BrandQRcodes reserves the right to terminate a participant's account and nullify any accrued
            commissions
            if it is suspected that the participant has violated these Terms or engaged in fraudulent or abusive
            behavior.
        </li>
    </ul>

    <h4 class="ps-2">6.8. Modification and Termination of Program</h4>
    <ul class="no-dots">
        <li>
            6.8.1 BrandQRcodes retains the right to modify or terminate the Program, including these Terms, at any
            time and
            for any reason without prior notice.
        </li>
    </ul>

    <p>
        By engaging in the BrandQRcodes Referral Program, you acknowledge that you have read, comprehended, and
        accepted
        these Terms and Conditions. BrandQRcodes reserves the right to alter these Terms at any time, and it is your
        responsibility to periodically review them. Continued participation in the Program following any modifications
        to
        the Terms will signify your consent to those changes.
    </p>

    <h2>7. Payment Policy</h2>
    <h4 class="ps-2">7.1. Payment Methods</h4>
    <ul class="no-dots">
        <li>7.1.1 We offer two payment methods for your convenience: credit cards and voucher codes. By using any of
            these payment methods, you acknowledge and agree to abide by the terms and conditions set forth by the
            payment providers. Please note that we do not accept other forms of payment at this time.
        </li>
    </ul>

    <h4 class="ps-2">7.2. Payment Processing</h4>
    <ul class="no-dots">
        <li>7.2.1 <b>Payment Authorization</b>: When you make a payment through our Website, you authorize us to process
            the payment and charge the specified amount to your chosen payment method. You must ensure that you have the
            necessary funds or credit available to cover the payment.
        </li>
        <li>7.2.2 <b>Payment Confirmation</b>: After successful payment processing, you will receive a confirmation
            email or receipt. This confirmation serves as proof of payment for the services you have purchased.
        </li>
    </ul>

    <h4 class="ps-2">7.3. Pricing and Fees</h4>
    <ul class="no-dots">
        <li>7.3.1 <b>Service Prices</b>: The prices for our services are displayed on our Website. We reserve the right
            to change our prices at any time, but such changes will not affect payments for services that have already
            been purchased.
        </li>
        <li>7.3.2 <b>Taxes</b>: You are responsible for any applicable taxes or fees associated with your purchase. The
            total amount due, including taxes, will be displayed before you make your payment.
        </li>
    </ul>

    <h4 class="ps-2">7.4. Eligibility for Refunds</h4>
    <ul class="no-dots">
        <li>7.4.1 <b>Refundable Services</b>: Refunds are only applicable to services purchased through BrandQRcodes.com
            that explicitly state they are eligible for refunds. Some services may be non-refundable, and this will be
            clearly indicated before purchase.
        </li>
        <li>7.4.2 <b>Timeframe</b>: To be eligible for a refund, you must request the refund within 14 days of the
            original purchase date. Refund requests received after this period may not be honored.
        </li>
    </ul>

    <h4 class="ps-2">7.5. Valid Reasons for Refunds</h4>
    <p>Refunds may be issued under the following circumstances:</p>
    <ul class="no-dots">
        <li>7.5.1 <b>Service Errors</b>: If we fail to deliver the purchased service or there are significant errors or
            defects in the service provided, you may be eligible for a refund. Please report any issues promptly to our
            customer support team.
        </li>
        <li>7.5.2 <b>Duplicate Payment</b>: In the event of accidental duplicate payments for the same service, a refund
            for the duplicate payment may be issued upon verification.
        </li>
    </ul>

    <h4 class="ps-2">7.6. Non-Refundable Scenarios</h4>
    <p>Refunds will not be issued under the following circumstances:</p>
    <ul class="no-dots">
        <li>7.6.1 <b>Change of Mind</b>: We do not issue refunds for services based on a change of mind or a decision to
            no longer use the service.</li>
        <li>7.6.2 <b>Misuse</b>: If we detect any misuse or violation of our terms of service, we reserve the right to
            deny refund requests.
        </li>
        <li>7.6.3 <b>Service Modifications</b>: Refunds will not be issued if the service has been used or partially
            used, or if modifications to the service have been made by the customer.
        </li>
    </ul>

    <h4 class="ps-2">7.7. Requesting a Refund</h4>
    <p>To request a refund, please follow these steps:</p>
    <ul class="no-dots">
        <li>7.7.1 <b>Contact Customer Support</b>: Send an email to our customer support team through <a
                routerLink="/contact-us?reason=2" target="_blank">here</a> with your refund request. Include your order
            number, the reason for the refund, and any supporting documentation or evidence.</li>
        <li>7.7.2 <b>Verification</b>: We will review your request and may require additional information or
            documentation to process the refund.
        </li>
        <li>7.7.3 <b>Refund Processing</b>: If your request is approved, we will initiate the refund process. Refunds
            will be issued to the original payment method used for the purchase.
        </li>
    </ul>

    <h4 class="ps-2">7.8. Security</h4>
    <ul class="no-dots">
        <li>7.8.1 We take security seriously and implement measures to protect your payment information. However, you
            are responsible for ensuring the security of your login credentials and payment details. We are not liable
            for any unauthorized access or breaches of security that may result in the misuse of your payment
            information.
        </li>
    </ul>

    <h4 class="ps-2">7.9. Changes to Payment Terms</h4>
    <ul class="no-dots">
        <li>7.9.1 We reserve the right to modify these Payment Terms at any time. Any changes will be effective
            immediately upon posting on our Website. It is your responsibility to review these Payment Terms regularly
            for updates.
        </li>
    </ul>

    <h2>8. Your Privacy</h2>

    <p>Please read <a routerLink="/privacy-policy">Privacy Policy</a></p><br>

    <h2>9. Reservation of Rights</h2>

    <p>
        We reserve the right to request that you remove all links or any particular
        link to our Website. You approve to immediately remove all links to our
        Website upon request. We also reserve the right to amen these terms and
        conditions and it’s linking policy at any time. By continuously linking to
        our Website, you agree to be bound to and follow these linking terms and
        conditions.
    </p><br>

    <h2>10. Removal of links from our website</h2>

    <p>
        If you find any link on our Website that is offensive for any reason, you
        are free to contact and inform us any moment. We will consider requests to
        remove links but we are not obligated to or so or to respond to you
        directly.
    </p>

    <p>
        We do not ensure that the information on this website is correct, we do not
        warrant its completeness or accuracy; nor do we promise to ensure that the
        website remains available or that the material on the website is kept up to
        date.
    </p><br>

    <h2>11. Eligibility</h2>
    <p>
        You must be at least 13 years of age to use our Services. If you are under
        18 years of age (or the age of legal majority where you live), you may use
        our Services only under the supervision of a parent or legal guardian who
        agrees to be bound by these Terms. If you are a parent or legal guardian of
        a user under the age of 18 (or the age of legal majority), you agree to be
        fully responsible for the acts or omissions of such user in relation to our
        Services. If you use our Services on behalf of another person or entity,
    </p>
    <ul class="no-dots">
        <li>(a) all references to “you” throughout these Terms will include that person or entity,</li>
        <li>(b) you represent that you are authorized to accept these Terms on that person’s or entity’s behalf, and
        </li>
        <li>(c) in the event you or the person or entity violates these Terms, the person or entity agrees to be
            responsible
            to us.</li>
    </ul>
    <br>

    <h2>12. Disclaimer</h2>

    <p>
        To the maximum extent permitted by applicable law, we exclude all
        representations, warranties and conditions relating to our website and the
        use of this website. Nothing in this disclaimer will:
    </p>

    <ul>
        <li>
            limit or exclude our or your liability for death or personal injury;
        </li>
        <li>
            limit or exclude our or your liability for fraud or fraudulent
            misrepresentation;
        </li>
        <li>
            limit any of our or your liabilities in any way that is not permitted
            under applicable law; or
        </li>
        <li>
            exclude any of our or your liabilities that may not be excluded under
            applicable law.
        </li>
    </ul>

    <p>
        The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer:
    </p>
    <ul class="no-dots">
        <li>(a) are subject to the preceding paragraph; and </li>
        <li>(b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort
            and
            for breach of statutory duty.</li>
    </ul>

    <p>
        As long as the website and the information and services on the website are
        provided free of charge, we will not be liable for any loss or damage of any
        nature.
    </p>
</div>

<app-footer></app-footer>